import { domainsConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addDomain = (state = initialState, action) => {
  switch (action.type) {
    case domainsConstants.ADD_DOMAIN_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case domainsConstants.ADD_DOMAIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case domainsConstants.ADD_DOMAIN_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case domainsConstants.ADD_DOMAIN_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
